import { jsx as _jsx } from "react/jsx-runtime";
import { Chip } from "@mui/material";
import HoverTooltip from "./hoverOverlay/HoverTooltip";
const AVATAR_COLORS = [
    { bg: "#FEF2F2", text: "#B42318" },
    { bg: "#FEF0C7", text: "#B54708" },
    { bg: "#D1FADF", text: "#067647" },
    { bg: "#E0EAFF", text: "#3538CD" },
    { bg: "#F4EBFF", text: "#6941C6" },
    { bg: "#E0F2FE", text: "#0369A1" },
    { bg: "#FFE4E6", text: "#BE123C" },
];
export default function CommonChip({ label, tooltip, className = "", sx = {}, index = 0, renderType = "chip", }) {
    const color = AVATAR_COLORS[index % AVATAR_COLORS.length];
    let element;
    if (renderType === "circle") {
        element = (_jsx("span", { className: className, style: {
                width: "28px",
                height: "28px",
                borderRadius: "50%",
                display: "inline-flex",
                alignItems: "center",
                justifyContent: "center",
                fontSize: "11px",
                fontWeight: 600,
                background: color.bg,
                color: color.text,
                // Slight horizontal overlap when rendering multiple circles
                marginLeft: index > 0 ? -6 : 0,
                ...sx,
            }, children: label }));
    }
    else if (renderType === "tag") {
        element = (_jsx("span", { className: className, style: {
                fontSize: "11px",
                fontWeight: 600,
                padding: "2px 8px",
                borderRadius: "8px",
                display: "inline-flex",
                alignItems: "center",
                justifyContent: "center",
                background: color.bg,
                color: color.text,
                ...sx,
            }, children: label }));
    }
    else {
        element = (_jsx(Chip, { label: label, className: className, size: "small", sx: {
                height: 20,
                fontSize: "11px",
                fontWeight: 600,
                backgroundColor: color.bg,
                color: color.text,
                "& .MuiChip-label": { padding: "0 6px" },
                ...sx,
            } }));
    }
    if (!tooltip)
        return element;
    return (_jsx(HoverTooltip, { title: tooltip, arrow: true, placement: "top", children: _jsx("span", { children: element }) }));
}
